/** Por qué volvió alguien al login desde el portal (`?error=` que pone el backend). */
const MENSAJES: Record<string, string> = {
  portal: 'El portal del DCC no autorizó el ingreso a esta aplicación.',
  sin_token: 'El portal no devolvió la identificación. Intenta de nuevo.',
  token_invalido: 'La identificación que devolvió el portal no es válida. Intenta de nuevo.',
  nonce: 'La solicitud de ingreso expiró o no corresponde a este navegador. Intenta de nuevo.',
  no_configurado: 'El ingreso con U-Pasaporte no está configurado en este ambiente.',
  sin_cuenta: 'Tu cuenta no tiene acceso a esta aplicación. Pídelo a quien la administra.',
  cuenta_inactiva: 'Tu cuenta está desactivada.',
}

export function mensajeErrorLogin(codigo: string | null): string | null {
  if (!codigo) return null
  return MENSAJES[codigo] ?? 'No se pudo iniciar sesión. Intenta de nuevo.'
}

/** Solo rutas internas del SPA: un `next` externo haría del login un redirector abierto. */
export function destinoSeguro(next: string | null, porDefecto = '/app'): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) return porDefecto
  return next
}

/** Iniciales para el avatar: primera y última palabra que empiecen con letra ('Admin (dev)' → 'A'). */
export function iniciales(nombre: string): string {
  const partes = nombre.split(/\s+/).filter((p) => /^\p{L}/u.test(p))
  if (!partes.length) return '··'
  return (partes[0][0] + (partes.length > 1 ? partes[partes.length - 1][0] : '')).toUpperCase()
}
